<template>
  <div class="goods-detail-page-wrap">
    <!-- 已取消合作进入 -->
    <div class="off-info">
      <img class="off-etc-icon" src="https://wecos.etczs.net/H5/etc-logo-h5-off.png" />
      <div class="off-title">请打开微信搜索“ETC助手”办理</div>
      <div class="off-tips">当前页面已不再提供相关服务，敬请谅解。</div>
      <div class="agreement">
        <span color-blue @click="goProtocol('USER_PRIVACY_PROTECTION_PROTOCOL')">用户隐私保护政策</span>
      </div>
    </div>
    <!--弹窗-->
    <popup ref="popup">
      <div slot="content" class="popup-container">
        <header>温馨提示</header>
        <div class="popup-content">
          <p>
            本页面将于10月1日正式下线，如需办理ETC及补缴ETC欠费，请前往微信小程序“ETC助手”办理和补缴。
          </p>
        </div>
        <div class="popup-footer">
          <button class="repay-btn" @click="goRepay">去支付</button>
          <!-- <button class="cancel-btn" @click="hidePopup">以后再说</button> -->
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
// 招行
// import cmblapi from 'cmblapi'
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
import ChannelMixin from '@/mixins/channelMixin'
// components
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import Modal from '@/components/cool.modal'
import Popup from '@/components/cool.popup'
// import NavigateHeader from '@/components/cool.navigateHeader'
// api
import ApplyApi from '@/api/apply.api'
import reconApply from '@/api/reconApply.api'
import UserApi from '@/api/user.api'
// config
import ETC from '@/config/etc.config'
// utils
import Plugins from '@/utils/plugins'
import ETCUtil from '@/utils/util.etc'
// store
import { mapState, mapMutations } from 'vuex'

const PROGRESS = [
  {
    icon: 'etc-icon-tianxie',
    title: '填写资料',
    text:
      '仅9座及9座以下的小型汽车办理，一辆车仅允许办理1张 ETC卡，填写车主信息、车牌和收取 ETC设备的收件地址。'
  },
  {
    icon: 'etc-icon-Checkthe',
    title: '选择办理方式',
    text: '可选择绑定银行卡免费办理 ETC'
  },
  {
    icon: 'etc-icon-tijiao',
    title: '交纳保证金',
    text: '交纳99元保证金后就立即发货，设备激活后原路返还'
  },
  {
    icon: 'etc-icon-bangdingyinhangqia',
    title: '绑定微信支付',
    text: '绑定微信支付，无需预充值，实现 ETC通行自动扣费，安全防盗刷'
  },
  {
    icon: 'etc-icon-anzhuang1',
    title: '安装激活',
    text:
      '上传激活设备所需信息后，按" ETC助手"小程序指引激活 ETC设备，即可通行使用'
  }
]

const questions = [
  {
    title: '是否全国通行？可以多车使用一个吗？',
    ans:
      'ETC助手支持全国29省高速通行（西藏和海南高速免费，港澳台暂无高速计划），一车一设备，专车专用。'
  },
  {
    title: '办理需要多久？',
    ans:
      '上传资料并绑定微信支付后，一般在1-3个工作日内完成你的设备定制，预计3天后可快递到你手上。'
  },
  {
    title: '不是车主本人是否能办理ETC？',
    ans: '可以办理，但需上传车主身份证资料。通行费用会从办理人的微信扣费。'
  },
  {
    title: '哪些车型可以办理？',
    ans: '暂只支持≤7座、蓝牌和绿牌的个人小型汽车办理。'
  },
  {
    title: '通行后如何扣费？',
    ans:
      '出站后将自动使用微信免密支付，扣除微信零钱或绑定的银行卡中的余额。扣费会有延迟，一般是1天内扣费，部分路段会有数天延迟。'
  },
  {
    title: '如何安装？',
    ans:
      '只需要根据ETC助手小程序上的步骤提示，打开手机蓝牙连接设备，1分钟即可完成自助安装。'
  },
  {
    title: '已经办理过ETC，如何在ETC助手重新办理？',
    ans: '已经办理过ETC的车辆，需要在原办理渠道注销才能重新申办。'
  }
]
const questions_zh = [
  {
    title: '是否全国通行？可以多车使用一个吗？',
    ans:
      'ETC助手支持全国29省高速通行（西藏和海南高速免费，港澳台暂无高速计划），一车一设备，专车专用。'
  },
  {
    title: '办理需要多久？',
    ans:
      '完成申办手续后，一般在1-3个工作日内完成你的设备定制，预计3天后可快递到你手上。'
  },
  {
    title: '不是车主本人是否能办理ETC？',
    ans:
      '可以办理，但需上传车主身份证资料。通行费用会从办理人绑定的支付账户上扣除。'
  },
  {
    title: '哪些车型可以办理？',
    ans: '暂只支持≤7座、蓝牌和绿牌的个人小型汽车办理。'
  },
  {
    title: '通行后如何扣费？',
    ans:
      '出站后将自动使用免密支付，扣除绑定的银行卡中的余额。扣费会有延迟，一般是1天内扣费，部分路段会有数天延迟。'
  },
  {
    title: '如何安装？',
    ans:
      '绑定订单后，只需要根据ETC助手小程序上的步骤提示，打开手机蓝牙连接设备，1分钟即可完成自助安装。'
  },
  {
    title: '已经办理过ETC，如何在ETC助手重新办理？',
    ans: '已经办理过ETC的车辆，需要在原办理渠道注销才能重新申办。'
  }
]

let customData = {
  isAndroid: false,
  cannotTip: '',
  isLogin: false,
  jumpParams: ''
}

export default {
  name: 'goodsDetail',
  mixins: [FunMixin, BiMixin, ChannelMixin],
  components: {
    Popup
    // NavigateHeader,
    // swiper,
    // SwiperSlide: swiperSlide,
    // Modal
  },
  data() {
    return {
      qaList: [
        {
          question: '车辆怎么办理ETC？',
          answer:
            '暂仅支持9座及9座以下的蓝牌、绿牌的小型汽车办理，暂不支持货车办理。需要提供车主本人身份证、车辆行驶证、车辆正面照片(含车牌)'
        },
        {
          question: 'ETC的办理费用？',
          answer:
            '办理ETC是免费的。为保障免费发行，办理时需要支付保证金，设备激活后即可全额返还，无任何年费、手续费、服务费'
        },
        {
          question: '办理需要多久才能收到设备？',
          answer:
            '35秒线上申请，提交完整车主资料后，预计2-5个工作日即可以收到ETC设备'
        }
      ],
      progress: PROGRESS,
      ETC,
      modalType: '',
      swiperOption: {
        direction: 'vertical',
        // autoplay: true,
        // autoplay: {delay: 2000, disableOnInteraction: false},
        initialSlide: 0,
        loop: true
      },
      commentSwiper: {
        slidesPerView: 'auto',
        // centeredSlides: true,
        freeMode: true,
        spaceBetween: 20
      },
      topApplys: {},
      comments: [{}, {}, {}],
      showUp: false,
      firstLoad: true
    }
  },
  computed: {
    questions() {
      if (this.appChannel === 'zhaohang') return questions_zh
      return questions
    },
    images() {
      return {
        kv: require('../../assets/goodsDetail/kv2.png'),
        service1:
          'https://wecos.etczs.net/assets/images/service-img-no1-0810.png',
        service2:
          'https://wecos.etczs.net/assets/images/service-img-no2-0810.png',
        service3:
          'https://wecos.etczs.net/assets/images/service-img-no3-0810.png',
        service4:
          'https://wecos.etczs.net/assets/images/service-img-no4-0810.png'
      }
    },
    ...mapState([
      'currentOrder',
      'userLocation',
      'userApplyStep',
      'currentCard',
      'applyStepList'
    ])
  },
  methods: {
    goProtocol(protocolName) {
      this.m_goPagesWithQ('agreement', {agreementType: protocolName, issuerId: ''})
    },
    goRepay() {
      this.m_goPages('throughRec_zh')
    },
    hidePopup() {
      this.$refs.popup.$emit('hidePopup')
    },
    goSpecialBack() {
      console.log('goSpecialBack')
    },
    UPUP() {
      window.scrollTo(0, 0)
    },
    startVideo() {
      this.$refs.video.play()
      this.$refs.video.setAttribute('controls', 'controls')
      this.video.start = true
      this.biLog({ eventID: 2001140 })
    },
    async showModal(t) {
      await this.m_clickDebounce('showModal')
      this.$refs.modal.$emit('showModal', {
        contentSlot: true,
        defaultFooter: false,
        parentHide: true,
        close: true
      })
      this.m_scroll(false)
      this.modalType = t
    },
    modalHide() {
      this.m_scroll(true)
    },
    // async getLocation() {
    //   let pos
    //   // 5秒后没获取到定位就跳转
    //   let timer = setTimeout(() => {
    //     return Promise.resolve('end')
    //   }, 5000)
    //   try {
    //     pos = await Plugins.getLocation(this.appChannel)
    //     console.log('plugin get location success', pos)
    //     this.setUserLocation({latitude: pos.latitude, longitude: pos.longitude})
    //   } catch (e) {
    //     console.log('get location err', e)
    //   }
    //   clearTimeout(timer)
    //   return Promise.resolve('end')
    // },
    async getUserOrderInfo(type) {
      sessionStorage.setItem('notFirstLoad', 1)
      console.log(
        'goods detail getUserOrderInfo type:',
        type,
        ' uid:',
        localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID)
      )
      try {
        const userInfo = await UserApi.getUserInfo()
        // const checkRepay = userInfo.user_cards && userInfo.user_cards.find(({card_id}) => card_id === 27)
        // 招行还款入口
        if (this.appChannel === 'zhaohang') {
          const res = await ApplyApi.getZHRepayStatus()
          if (res.has_repayment) {
            this.$refs.popup.$emit('showPopup', {class: 'zhaohang-repay-popup'})
            return
          }
        }
        customData.jumpParams = {
          orderSn: userInfo.apply_order_sn
        }
        // 有卡用户进入绑定成功页
        // 跳转后取消自动
        localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, '')
        if (userInfo.has_card) {
          if (this.appChannel === 'zhaohang') {
            const zhaohangCard = userInfo.user_cards.find(
              ele => ele.toll_pay_channel === 3
            )
            if (zhaohangCard) {
              if (zhaohangCard.entrust_status !== 1) {
                return this.m_showConfirm({ content: '你的ETC扣款协议已失效，ETC费用已无法自动扣款，我们根据高速公路收费中心要求，已将你的ETC添到全国高速公路黑名单。为了不影响你的出行，请尽快完成重新签约，签约成功后我们将你的ETC恢复正常使用', noCancel: true, confirmBtn: '重新签约' }).then(
                  async res => {
                    if (res) {
                      try {
                        const res = await reconApply.entrustSignContract({
                          payment_mode: 5,
                          purchase_party: 6
                        })
                        if (res && res.contract) {
                          localStorage.setItem('zhanghangEntrust', 'yes')

                          console.log(
                            'res.contractres.contractres.contract',
                            res.contract
                          )
                          location.href =
                            res.contract.url +
                            '&jsonRequestData=' +
                            res.contract.tmpData
                          // this.m_awaitTime(2000)
                          // this.getEntrustStatus(4000)
                        }
                      } catch (error) {}
                    }
                  }
                )
              } else {
                // 招行签约返回需要提示
                if (localStorage.getItem('zhanghangEntrust') === 'yes') {
                  localStorage.removeItem('zhanghangEntrust')
                  await this.m_showConfirm({ content: '你的ETC扣款协议已签约成功，若无欠费等异常行为，我们将为你在48小时内恢复ETC的正常使用，若还有欠费请主动进行还款', noCancel: true })
                }
              }
            }
          }
          customData.jumpParams = {
            ...customData.jumpParams,
            cardId: userInfo.user_cards[0].id,
            plateNo: userInfo.user_cards[0].plate_no,
            issuerName: userInfo.user_cards[0].card_name
          }
          return ETCUtil.goApplyPage(
            'bindSuccess',
            {},
            this.$router,
            customData.jumpParams,
            1
          )
        }
        // 重构订单不同判断订单走不通的接口
        // 用户没卡
        if (userInfo.apply_order_sn) {
          // 有订单
          // 查询用户订单reconApply
          const {
            order,
            reject_reason,
            step_list
          } = await reconApply.getApplyCurrentOrder({
            order_sn: userInfo.apply_order_sn
          })
          // 保存发卡方，卡信息
          this.setCurrentIssuer(order.card_issuer)
          this.setCurrentCard(order.card)
          this.setCurrentOrder({ reject_reason, ...order })
          this.setApplyStepList(step_list)
          customData.jumpParams.plateNo = this.currentOrder.plate_no || ''
          return ETCUtil.goApplyPage(
            'goodsAddress',
            step_list,
            this.$router,
            customData.jumpParams,
            0,
            type
          )
        }
        if (type === 'click') {
          this.$router.push('goodsAddress')
        }
      } catch (e) {
        console.log('goods detail getUserOrderInfo catch', e)
        throw new Error('goods detail  getUserOrderInfo err' + e)
      } finally {
        console.log('goods detail getUserOrderInfo finally')
        this.m_loadingClose()
      }
    },
    async apply() {
      if (customData.cannotTip) {
        this.m_showConfirm({ content: customData.cannotTip })
        return
      }
      // 招行签约后返回 会出现无参数的状态
      if (
        !customData.isLogin &&
        !localStorage.getItem(ETC.LOCAL_STORAGE_KEY.TOKEN)
      ) {
        let { enterP } = this
        console.log('enterP', enterP)
        // 如果没有UID则调用手机号码登录
        if (
          !enterP.uid &&
          !enterP.userToken &&
          !enterP.qz_gdt &&
          this.appChannel !== 'zuizhuhai'
        ) {
          // 登录后需要调用部分该页面逻辑
          this.$eventBus.$once('onLogin', async res => {
            if (res) {
              customData.isLogin = true
              // 登录成功挟持router把登录页面replace掉阻止返回
              let cancelEach = this.$router.beforeEach((to, from, next) => {
                if (from.name === 'verifyPhone') {
                  cancelEach()
                  this.$router.replace(to)
                }
              })
              await this.initLoginStore()
              this.apply()
            }
          })
          this.$router.push('/verify-phone?callback=onLogin')
          return
        } else {
          customData.isLogin = await this.c_channelLogin()
          if (!customData.isLogin) return
        }
      }
      this.m_showLoading()
      // 没有地理位置，点击获取地理位置
      try {
        this.biLog({ eventID: 2001129 })
        // if (
        //   localStorage.getItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD) === 'yes'
        // ) {
        //   }
        await this.getUserOrderInfo('click')
        // else {
        //   console.log(
        //     23232,
        //     'goodsAddress',
        //     this.applyStepList.step_list,
        //     this.$router,
        //     'click',
        //     customData.jumpParams
        //   )
        //   ETCUtil.goApplyPage(
        //     'goodsAddress',
        //     this.applyStepList.step_list,
        //     this.$router,
        //     customData.jumpParams,
        //     'click'
        //   )
        // }
      } catch (e) {
        throw new Error('goods detail apply err' + e)
      } finally {
        this.m_loadingClose()
      }
    },
    async initLoginStore() {
      try {
        this.m_showLoading()
        // province freight_fee
        // 根据ip定位  浏览器定位太过耗时
        // if (!this.userLocation.latitude) {
        //   await this.getLocation()
        // }
        const {
          issuer,
          card,
          comments,
          recent_orders,
          province
        } = await reconApply.getApplyGoodsDetail({
          // longitude: this.userLocation.longitude,
          // latitude: this.userLocation.latitude
        })
        this.setUserLocation({ province })
        this.setCurrentCard(card)
        this.setCurrentIssuer(issuer)
        this.comments = comments
        recent_orders && (this.topApplys = recent_orders[0])
        // 如果是支付成功回来
        const pageType = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD)
        if (!pageType || pageType === 'yes') {
          await this.m_awaitTime(3000)
          this.getUserOrderInfo('auto')
        } else if (!sessionStorage.getItem('notFirstLoad')) {
          this.getUserOrderInfo('auto')
        }
      } catch (e) {
        console.log('goods detail err', e)
      } finally {
        this.m_loadingClose()
      }
    },
    ...mapMutations([
      'setCurrentCard',
      'setCurrentIssuer',
      'setUserApplyStep',
      'setUserLocation',
      'setCurrentOrder',
      'setApplyStepList'
    ])
  },
  async created() {
    console.log(process.env)
    if (this.appChannel === 'zhaohang') {
      document.title = '服务暂停'
      await Plugins.appStartDefer.promise
      console.log('zhaohang ver ', this.c_channelAppVersion())
      if (this.c_channelAppVersion() >= '7.4.0') {
        // cmblapi.applet({
        //   api: 'checkAppletContainer',
        //   success: () => { // 如果是小程序容器，这里回调
        //     console.log('checkAppletContainer success')
        //     cmblapi.applet({
        //       api: 'setAppletBackButton',
        //       params: {
        //         btnAction: 'default' // 支持default或executeJs
        //         // btnActionContent:'null/window.history.go(-1)'
        //       },
        //       success: () => {
        //         console.log('setAppletBackButton success')
        //         // window.cmblapi.applet({
        //         //   api: 'popWindow',
        //         //   fail: (res) => {
        //         //     console.log('popWindow fail', res)
        //         //   }
        //         // })
        //       },
        //       fail: (res) => {
        //         console.log('setAppletBackButton fail', res)
        //       }
        //     })
        //   },
        //   fail: (res) => { // 如果不是小程序容器，这里回调
        //     console.log('checkAppletContainer fail, res')
        //   }
        // })
      } else {
        if (!this.c_channelIsLogin()) return
        window.CMBLS.TopBarUI = window.CMBLS.TopBarUI || {}
        window.CMBLS.TopBarUI.callback = (id, message) => {
          console.log('TopBarUI callback ' + id)
          if (customData.isAndroid) {
            window.location = 'http://cmbandroid/tool'
          } else {
            window.location = 'http://cmbiphone/tool'
          }
        }
        window.cmblsJSExecutor(
          'http://cmbls/TopBarUI?id=2222&left_btn_style=' +
            encodeURIComponent(
              JSON.stringify([
                {
                  btnType: 'goback',
                  actionType: 'callback'
                }
              ])
            )
        )
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    // console.log('beforeRouteLeave bbbbbb')
    localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, '')
    console.log('this.appChannel', this.appChannel)
    if (this.appChannel === 'zhaohang') {
      if (this.c_channelAppVersion() >= '7.4.0') {
      } else {
        window.CMBLS.TopBarUI = window.CMBLS.TopBarUI || {}
        window.CMBLS.TopBarUI.successCallback = (id, message) => {
          console.log('TopBarUI ' + id)
        }
        window.cmblsJSExecutor(
          'http://cmbls/TopBarUI?id=111&left_btn_style=' +
            encodeURIComponent(
              JSON.stringify([
                {
                  btnType: 'goback',
                  actionType: 'historygoback'
                }
              ])
            )
        )
      }
    }
    next()
  },
  async mounted() {
    console.log('goodsDetail mounted 233334')
    await Plugins.appStartDefer.promise
    const enterP = (this.enterP =
      Object.keys(this.$route.query).length === 0
        ? Object.keys(this.$route.params).length === 0
          ? {}
          : this.$route.params
        : this.$route.query)
    customData.isAndroid = await this.m_isAndroid()
    let appChannel = enterP.channel || this.appChannel || ''
    if (!appChannel || !ETC.APP_LOGIN_TYPES[appChannel]) {
      customData.cannotTip = '入口已关闭，请前往微信“ETC助手”小程序办理'
      this.m_showConfirm({ content: customData.cannotTip })
      return
    }

    // 处理滴滴uid占位符问题：
    if (enterP.uid === '__UID__' /* || enterP.uid === 'XXXX' */) {
      enterP.uid = void 0
    }

    // 若页面没有参数
    customData.isLogin = ETCUtil.getToken()
    if (
      (!enterP.uid || !enterP.code) &&
      !enterP.userToken &&
      !enterP.qz_gdt &&
      !localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID)
    ) {
      // customData.cannotTip = appChannel ? '请前往"' + ETC.APP_EVNS_CN[appChannel] + '"查看详情' : '该页面无效，请在微信搜索“etc助手”小程序办理'
      // this.m_showConfirm({content: customData.cannotTip})
      if (customData.isLogin) {
        return this.initLoginStore()
      }
    }
    if (!customData.isLogin) {
      customData.isLogin = await this.c_channelLogin()
    }
    if (!customData.isLogin) return
    this.initLoginStore()
  }
}
</script>

<style scoped lang="scss">
@import '../../style/cool.practical';

.goods-detail-page-wrap {
  .off-info {
    padding: 0 40px;
    .off-etc-icon {
      display: block;
      width: 160px;
      height: 160px;
      margin: 160px auto 0;
    }
    .off-title {
      font-weight: 500;
      padding-top: 40px;
      font-size: 40px;
      line-height: 60px;
      color: #333;
      text-align: center;
    }
    .off-tips {
      text-align: center;
      padding-top: 24px;
      font-style: 28px;
      line-height: 42px;
      color: #999;
    }
    .agreement{
      line-height: 40px;
      font-size: 26px;
      color: #333333;
      align-self: flex-start;
      text-align: center;
      position: fixed;
      bottom: 28px;
      left: 0;
      width: 100%;
    }
  }
  .goods-detail-page2 {
    padding-bottom: 130px;
    .top-img {
      font-size: 0;
      img {
        width: 100%;
        height: 650px;
      }
    }
    .top-tip {
      @extend %flex-center-start;
      font-size: 26px;
      padding-left: 35px;
      margin-top: 30px;
      .tip-title {
        border-radius: 20px 0 20px 0 / 20px 0 20px 0;
        padding: 1px 12px;
        border: 1px solid;
        margin-right: 20px;
      }
    }
    .apply-title {
      margin-top: 50px;
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      line-height: 50px;
      padding: 0 40px;
    }
    .apply-steps {
      background-color: #fff;
      //padding: 0 40px 0 60px;
      @extend %apply-progress;
      .progress-view {
        padding: 0 40px 0 60px;
      }
      .progress-title {
        font-size: 26px;
        height: 37px;
        line-height: 37px;
        .progress-icon {
          width: 70px;
          height: 70px;
          &.iconfont {
            font-size: 46px;
          }
        }
      }
      .progress-content {
        margin-bottom: 50px;
      }
    }
    .apply-service {
      border-top: 20px solid #f5f5f5;
      .service-content {
        padding: 30px 70px 50px;
        @extend %flex-space-between;
        .service {
          width: 120px;
          text-align: center;
          img {
            width: 50px;
            height: 50px;
          }
          p {
            font-size: 26px;
            margin-top: 10px;
          }
        }
      }
    }
    .apply-questions {
      border-top: 20px solid #f5f5f5;
      .questions {
        padding: 0 40px;
      }
      .question {
        padding: 20px 40px 20px 0;
        border-bottom: 1px solid $border-bottom-color;
        .question-icon {
          width: 36px;
          height: 36px;
          position: relative;
          display: inline-block;
          line-height: 36px;
          text-align: center;
          margin-right: 20px;
          span {
            z-index: 2;
            position: relative;
            font-size: 22px;
            color: #ffffff;
          }
          i {
            position: absolute;
            font-size: 36px;
            top: 0;
            left: 0;
            z-index: 1;
            color: #dddddd;
          }
        }
        .title {
          .title-content {
            font-size: 26px;
            color: #333333;
          }
        }
        .answer {
          font-size: 26px;
          color: #999999;
          margin-top: 5px;
          margin-left: 56px;
        }
      }
      .more-question {
        padding: 30px 0;
        text-align: center;
        line-height: 40px;
        span {
          font-size: 28px;
          color: #0094ee;
        }
      }
    }
  }
  .goods-detail-page {
    background-color: #f5f5f5;
    padding-bottom: 130px;
    .title {
      padding: 30px 40px 0;
      @extend %flex-space-between;
      .label {
        padding-left: 24px;
        font-size: 30px;
        color: #333333;
        .title-tip {
          position: absolute;
          margin-left: 2px;
          bottom: 20px;
          padding: 2px 15px;
          background-image: linear-gradient(-180deg, #0de2a4 30%, #15c3c3 100%);
          color: #ffffff;
          font-size: 20px;
          border-radius: 20px 20px 20px 0/20px 20px 20px 0;
          white-space: nowrap;
        }
        @include title-before(4px, 28px);
      }
      .title-right {
        font-size: 26px;
      }
    }
    .top-tip {
      background-color: #e1f4ee;
      height: 80px;
      line-height: 80px;
      @extend %flex-space-between;
      padding: 0 30px 0 35px;
      font-size: 26px;
      .tip-title {
        color: #ffffff;
        border-radius: 20px 0 20px 0 / 20px 0 20px 0;
        background-color: $yellow;
        padding: 2px 12px;
        margin-right: 10px;
      }
      i {
        font-size: 28px;
      }
    }
    .goods-top {
      background-color: #83969f;
      /*padding-bottom: 30px;*/
      .top-info-bg {
        position: relative;
        font-size: 0;
        background-color: #fff;
        .etc-icon-start {
          font-size: 140px;
          color: #ffffff;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          z-index: 9;
          opacity: 0.6;
        }
      }
      .top-info-img {
        height: 655px;
        width: 100%;
        z-index: 8;
      }
    }
    .goods-info {
      background-color: #fff;
      padding-bottom: 50px;
      .top-apply-swiper {
        height: 48px;
        line-height: 48px;
        margin: inherit;
        color: #666666;
        font-size: 24px;
        @extend %flex-center-end;
        img {
          width: 36px;
          height: 36px;
          border-radius: 18px;
          background-color: #d8d8d8;
          margin-right: 10px;
        }
      }
      .obu-info {
        /*margin: 30px 40px 0;*/
        margin-top: 30px;
        text-align: center;
        font-size: 0;
        position: relative;
        .img-info {
          width: 670px;
          height: 388px;
        }
        .tip-info {
          width: 100%;
          position: absolute;
          font-size: 30px;
          bottom: 25px;
          .num {
            font-size: 34px;
            font-weight: bold;
          }
          .tip {
            margin-top: 7px;
            font-size: 20px;
            color: #999999;
          }
        }
      }
    }
    .apply-info {
      margin-top: 20px;
      background-color: #fff;
      padding-bottom: 45px;
      .tip-info {
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        margin-top: 30px;
      }
      .applys {
        padding: 30px 35px 45px;
        @extend %flex-space-around;
        .line {
          width: 72px;
          height: 1px;
          background-color: #dddddd;
        }
        .apply {
          text-align: center;
          position: relative;
          color: #333333;
          font-size: 28px;
          i {
            font-size: 60px;
            color: #666666;
          }
          p {
            position: absolute;
            bottom: -45px;
            white-space: nowrap;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .price-info {
      background-color: #fff;
      margin-top: 20px;
      padding-bottom: 50px;
      .price-content {
        position: relative;
        width: 670px;
        height: 158px;
        margin: 30px auto 0;
        img {
          width: 670px;
          height: 158px;
        }
        .info {
          position: absolute;
          font-size: 32px;
          font-weight: bold;
          top: 30px;
          left: 45px;
          .tip {
            margin-top: 20px;
            font-size: 24px;
            font-weight: normal;
          }
        }
      }
    }
    .comments-info {
      margin-top: 20px;
      background-color: #fff;
      .comments {
        margin-top: 30px;
        padding-bottom: 50px;
        .comment-swiper {
          /*width: 492px;*/
          padding-left: 20px;
        }
        .comment {
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 20px;
          @extend %flex-space-around;
          height: 224px;
          width: 492px;
          .comment-info {
            flex: 1;
            margin-right: 20px;
            .comment-title {
              @extend %flex-center-start;
            }
            img {
              width: 52px;
              height: 52px;
              background-color: #d8d8d8;
              margin-right: 20px;
              border-radius: 50%;
            }
            span {
              font-size: 26px;
              color: #999999;
            }
            .comment-pre {
              font-size: 26px;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 20px;
              height: 111px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
          }
          .comment-imgs {
            position: relative;
            flex-shrink: 0;
            width: 184px;
            height: 184px;
            img {
              width: 184px;
              height: 184px;
              background-color: #d8d8d8;
              border-radius: 5px;
            }
            .img-num {
              position: absolute;
              border-radius: 12px;
              font-size: 20px;
              color: #333333;
              padding: 0 8px;
              top: 5px;
              right: 10px;
              background-color: #fff;
            }
          }
        }
        .more-comments {
          width: 224px;
          height: 224px;
          line-height: 224px;
          text-align: center;
          border: 1px solid #eee;
          border-radius: 8px;
          font-size: 24px;
          color: #999999;
          margin-right: 20px;
        }
      }
    }
    .qa-info {
      margin-top: 20px;
      background-color: #fff;
      .qa-content {
        margin: 10px 40px 0;
        padding-bottom: 40px;
        .qa-li {
          background-color: #f9f9f9;
          border-radius: 10px;
          margin-top: 20px;
          padding: 20px;
        }
        .qa-title {
          font-size: 26px;
          font-weight: bold;
          .question-icon {
            width: 36px;
            height: 36px;
            position: relative;
            display: inline-block;
            line-height: 36px;
            text-align: center;
            margin-right: 20px;
            span {
              z-index: 2;
              position: relative;
              font-size: 22px;
              color: #ffffff;
            }
            i {
              position: absolute;
              font-size: 36px;
              top: 0;
              left: 0;
              z-index: 1;
            }
          }
        }
        .qa-ans {
          font-size: 24px;
          margin-left: 56px;
          margin-top: 10px;
        }
        .warm-tip {
          margin-top: 30px;
          header {
            font-size: 26px;
          }
          .tip {
            margin-top: 20px;
            font-size: 24px;
          }
        }
        /*img{*/
        /*width: 100%;*/
        /*}*/
      }
    }
  }
  .bottom-wrap {
    margin-top: 20px;
    height: 108px;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 11;
    @extend %flex-start;
    .service {
      width: 150px;
      height: 100%;
      background-color: #fff;
      text-align: center;
      font-size: 24px;
      color: #666666;
      @extend %flex-center-column;
    }
    .button {
      flex: 1;
      //background-color: $primary-color;
      height: 108px;
      line-height: 108px;
      text-align: center;
      font-size: 36px;
      color: #ffffff;
      font-weight: bold;
    }
  }
  .up-up {
    position: fixed;
    transform: translateZ(0);
    width: 80px;
    height: 80px;
    line-height: 80px;
    right: 20px;
    bottom: 180px;
    border-radius: 50%;
    border: 1px solid;
    text-align: center;
    background-color: #fff;
    z-index: 8;
    i {
      font-size: 44px;
    }
  }
  .apply-modal {
    background-color: #fff;
    .header {
      padding: 40px 0;
      text-align: center;
      font-size: 38px;
      color: #333333;
      font-weight: bold;
    }
    .apply-modal-progress {
      padding: 0 35px 30px;
      .progress-title {
        line-height: 42px;
        height: 42px;
        @extend %flex-align-center;
        .etc-icon-quan {
          font-size: 26px;
        }
        .loading {
          width: 32px;
          height: 32px;
          margin-left: 20px;
          margin-top: -4px;
        }
        span {
          margin-left: 30px;
          font-size: 30px;
          color: #333333;
          font-weight: bold;
        }
      }
      .progress-content {
        min-height: 60px;
        position: relative;
        @extend %flex-space-between;
        .dots {
          height: 100%;
          width: 8px;
          background: repeat-y
            url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAaCAYAAACO5M0mAAAAAXNSR0IArs4c6QAAAJhJREFUOBFjYBgF1AgBRpghnz59t/37918pkG8CFTvDzMzUzcfHeRjEByv88OFrFZDd8v//f7hGsCQj4z8gXSsgwN3GCDLp379/B4CKmECS6IARqJiJicmBBWIddkUgTSADQGpApsDchG4YMt8Eq3XIKmBskMIzMA4e+gzRnmGChlMdyHfoJkLFakFq4OFGKMDRDRnlkxcCACE1QunvZaY+AAAAAElFTkSuQmCC');
          background-size: 8px;
          position: absolute;
          top: 0;
          left: 9px;
        }
        .info {
          font-size: 28px;
          color: #666666;
          line-height: 37px;
          padding: 10px 0 45px 56px;
          img {
            width: 569px;
            height: 157px;
            margin-top: 20px;
          }
        }
      }
    }
  }
  .country-modal {
    background-color: #fff;
    padding: 40px;
    .header {
      padding-bottom: 10px;
      font-size: 38px;
      font-weight: bold;
      line-height: 54px;
      text-align: center;
      color: #333333;
    }
    .tip {
      font-size: 28px;
      line-height: 40px;
      text-align: center;
      color: #666666;
      padding-bottom: 20px;
    }
    .pre {
      font-size: 26px;
      text-indent: 2em;
      color: #666666;
      line-height: 40px;
      padding-top: 20px;
      strong {
        color: #151515;
      }
    }
  }
  .zhaohang-repay-popup {
    .popup-container {
      padding: 40px 40px 30px;
      header {
        font-size: 40px;
        line-height: 54px;
        text-align: center;
        font-weight: bold;
      }
      .popup-content {
        margin-top: 40px;
        font-size: 28px;
        line-height: 42px;
        color: #666666;
      }
      .popup-footer {
        margin-top: 52px;
        .repay-btn {
          width: 480px;
          height: 80px;
          line-height: 80px;
          background: linear-gradient(
            180deg,
            rgba(13, 226, 164, 1) 0%,
            rgba(21, 195, 195, 1) 100%
          );
          border-radius: 45px;
          color: #ffffff;
          font-size: 32px;
          text-align: center;
          display: block;
          margin: 0 auto;
        }
        .cancel-btn {
          color: #666666;
          font-size: 28px;
          display: block;
          margin: 40px auto;
        }
      }
    }
  }
}

</style>
